<template>
  <div class="form-container">
    <div>
      <b-modal
        id="auth-form"
        class="text-left"
        hide-footer
        ref="signUpModalRef"
      >
        <slot name="content"></slot>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { bus } from "@/main";

export default {
  mounted() {
    bus.$on("openSignUpModal", () => {
      if (this.$refs.signUpModalRef) this.$refs.signUpModalRef.show();
    });
  }
};
</script>

<style lang="scss">
#auth-form {
  .modal-header {
    min-height: 150px;
    background-image: url("~@/assets/img/stylists2.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
  }

  .modal-body {
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/formModal/FormModalShell.vue